<template lang="html">
<v-container>
  <v-layout row class="hidden-sm-and-down">
    <v-container>
      <v-card >
        <v-container>

          <v-layout row>
            <h3 class="display-1 font-weight-bold">{{$t('APPFEATURES')}}</h3>
          </v-layout>
          <v-list>
            <v-card color="grey lighten-2" elevation="8">

            <v-divider></v-divider>
            <v-list-tile v-for="el in app" >
              <v-list-tile-content >
                <v-layout row>
                  <v-icon :color="el.color">{{el.icon}}</v-icon>
                  <div style="margin-left: 5px;">
                    {{el.str}}
                  </div>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
          </v-card>
          </v-list>

        </v-container>
      </v-card>
    </v-container>
    <v-container>
      <v-card>
        <v-container>

          <v-layout row >
            <h3 class="display-1 font-weight-bold">{{$t('APPLITEFEATURES')}}</h3>
          </v-layout>

          <v-list >
          <v-card color="grey lighten-2" elevation="8">
          <v-divider></v-divider>
            <v-list-tile v-for="el in applite">
              <v-list-tile-content>
                <v-layout row >
                  <v-icon :color="el.color">{{el.icon}}</v-icon>
                  <div style="margin-left: 5px;">
                    {{el.str}}
                  </div>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
          </v-card>
          </v-list>
        </v-container>
      </v-card>
    </v-container>
  </v-layout>
  <v-layout column class="hidden-md-and-up">
    <v-container>
      <v-card >
        <v-container>

          <v-layout row>
            <h3 class="display-1 font-weight-bold">{{$t('APPFEATURES')}}</h3>
          </v-layout>
          <v-list>
            <v-card color="grey lighten-2" elevation="8">

            <v-divider></v-divider>
            <v-list-tile v-for="el in app" >
              <v-list-tile-content >
                <v-layout row>
                  <v-icon :color="el.color">{{el.icon}}</v-icon>
                  <div style="margin-left: 5px;">
                    {{el.str}}
                  </div>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
          </v-card>
          </v-list>

        </v-container>
      </v-card>
    </v-container>
    <v-container>
      <v-card>
        <v-container>

          <v-layout row >
            <h3 class="display-1 font-weight-bold">{{$t('APPLITEFEATURES')}}</h3>
          </v-layout>

          <v-list >
          <v-card color="grey lighten-2" elevation="8">
          <v-divider></v-divider>
            <v-list-tile v-for="el in applite">
              <v-list-tile-content>
                <v-layout row >
                  <v-icon :color="el.color">{{el.icon}}</v-icon>
                  <div style="margin-left: 5px;">
                    {{el.str}}
                  </div>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
          </v-card>
          </v-list>
        </v-container>
      </v-card>
    </v-container>
  </v-layout>

</v-container>
</template>

<script>
export default {
  data() {
    return {
      app: [{
          str: this.$t('compare.MAP'),
          icon: 'done',
          color: 'green'
        },
        {
          str: this.$t('compare.VIEW'),
          icon: 'done',
          color: 'green'
        },
        {
          str: this.$t('compare.VIEWALL'),
          icon: 'done',
          color: 'green'
        },
        {
          str: this.$t('compare.ONLYUSERCROP'),
          icon: 'done',
          color: 'green'
        },
        {
          str: this.$t('compare.WATER'),
          icon: 'done',
          color: 'green'
        },
        {
          str: this.$t('compare.YIELD'),
          icon: 'done',
          color: 'green'
        },
        {
          str: this.$t('compare.COMPARE'),
          icon: 'done',
          color: 'green'
        },
        {
          str: this.$t('compare.COMPAREALL'),
          icon: 'done',
          color: 'green'
        },
        {
          str: this.$t('compare.METEODATA'),
          icon: 'done',
          color: 'green'
        },
        {
          str: this.$t('compare.METEODATAUSER'),
          icon: 'done',
          color: 'green'
        },
        {
          str: this.$t('compare.DATAFILTER'),
          icon: 'done',
          color: 'green'
        },
        {
          str: this.$t('compare.DATAFILTERMORE'),
          icon: 'done',
          color: 'green'
        },
        {
          str: this.$t('compare.USERGROUPADD'),
          icon: 'done',
          color: 'green'
        },
        {
          str: this.$t('compare.USERGROUPVUE'),
          icon: 'done',
          color: 'green'
        },
        {
          str: this.$t('compare.USERGROUPMEMBER'),
          icon: 'done',
          color: 'green'
        }
      ],
      applite: [{
          str: this.$t('compare.MAP'),
          icon: 'done',
          color: 'green'
        },
        {
          str: this.$t('compare.VIEW'),
          icon: 'done',
          color: 'green'
        },
        {
          str: this.$t('compare.VIEWALL'),
          icon: 'clear',
          color: 'red'
        },
        {
          str: this.$t('compare.ONLYUSERCROP'),
          icon: 'clear',
          color: 'red'
        },
        {
          str: this.$t('compare.WATER'),
          icon: 'done',
          color: 'green'
        },
        {
          str: this.$t('compare.YIELD'),
          icon: 'clear',
          color: 'red'
        },
        {
          str: this.$t('compare.COMPARE'),
          icon: 'done',
          color: 'green'
        },
        {
          str: this.$t('compare.COMPAREALL'),
          icon: 'clear',
          color: 'red'
        },
        {
          str: this.$t('compare.METEODATA'),
          icon: 'done',
          color: 'green'
        },
        {
          str: this.$t('compare.METEODATAUSER'),
          icon: 'clear',
          color: 'red'
        },
        {
          str: this.$t('compare.DATAFILTER'),
          icon: 'done',
          color: 'green'
        },
        {
          str: this.$t('compare.DATAFILTERMORE'),
          icon: 'clear',
          color: 'red'
        },
        {
          str: this.$t('compare.USERGROUPADD'),
          icon: 'clear',
          color: 'red'
        },
        {
          str: this.$t('compare.USERGROUPVUE'),
          icon: 'clear',
          color: 'red'
        },
        {
          str: this.$t('compare.USERGROUPMEMBER'),
          icon: 'clear',
          color: 'red'
        }
      ]
    }
  }
}
</script>

<style lang="css" scoped>
</style>
